const jobCategoryIdToNameMapping = {
  // Old job categories for backward compatability
  job_category_01: "Auszubildender, Praktikant oder Student ",
  job_category_02: "Finanzdienstleistungen, Rechnungswesen und Steuerberatung ",
  job_category_03: "Gesundheit, Soziales, Lehre und Erziehung ",
  job_category_04: "IT Jobs ",
  job_category_05: "Mobilität und Logistik ",
  job_category_06: "Produktion, Handwerk und Technische Berufe ",
  job_category_07: "Tourismus-, Hotel- und Gaststättenberufe ",
  job_category_08: "Traditional and New Media Jobs ",
  job_category_09: "Unternehmensorganisation, Recht und Verwaltung ",
  job_category_10: "Vertrieb, Verkauf und Einkauf ",
  job_category_11: "Sonstige ",

  // New Job category ids
  L1000_L2000_L3000: "Sonstige",
  L1000_L2001_L3000: "Darstellende und unterhaltende Berufe",
  L1001_L2000_L3000: "Auszubildender, Praktikant oder Student",
  L1001_L2001_L3000: "Auszubildender",
  L1001_L2002_L3000: "Praktikant",
  L1001_L2003_L3000: "Student",
  L1001_L2004_L3000: "Schüler",
  L1001_L2005_L3000: "Trainee",
  L1002_L2000_L3000: "Bau, Architektur, Vermessung und Gebäudetechnik",
  L1002_L2001_L3000: "Bauplanungs-, Architektur- und Vermessungsberufe",
  L1002_L2002_L3000: "Hoch- und Tiefbauberufe",
  L1002_L2003_L3000: "(Innen-)Ausbauberufe",
  L1002_L2004_L3000: "Gebäude- und versorgungstechnische Berufe",
  L1003_L2000_L3000: "Finanzdienstleistungen, Rechnungswesen und Steuerberatung",
  L1003_L2001_L3000: "Berufe in Finanzdienstleistungen, Rechnungswesen und Steuerberatung",
  L1004_L2000_L3000: "Gesundheit",
  L1004_L2001_L3000: "Medizinische Gesundheitsberufe",
  L1004_L2002_L3000:
    "Nichtmedizinische Gesundheits-, Körperpflege- und Wellnessberufe, Medizintechnik",
  L1005_L2000_L3000: "IT Jobs",
  L1005_L2001_L3000: "Informatik-, Informations- und Kommunikationstechnologieberufe",
  L1006_L2000_L3000: "Land-, Forst- und Tierwirtschaft und Gartenbau",
  L1006_L2001_L3000: "Land-, Tier- und Forstwirtschaftsberufe",
  L1006_L2002_L3000: "Gartenbauberufe und Floristik",
  L1007_L2000_L3000: "Mobilität und Logistik",
  L1007_L2001_L3000: "Verkehrs- und Logistikberufe (außer Fahrzeugführung)",
  L1007_L2002_L3000: "Führer/innen von Fahrzeug- und Transportgeräten",
  L1008_L2000_L3000: "Produktion und Handwerk",
  L1008_L2001_L3000:
    "Rohstoffgewinnung und -aufbereitung, Glas- und Keramikherstellung und -verarbeitung",
  L1008_L2002_L3000: "Kunststoffherstellung und -verarbeitung, Holzbe- und -verarbeitung",
  L1008_L2003_L3000: "Papier- und Druckberufe, technische Mediengestaltung",
  L1008_L2004_L3000: "Metallerzeugung und -bearbeitung, Metallbauberufe",
  L1008_L2005_L3000: "Textil- und Lederberufe",
  L1008_L2006_L3000: "Lebensmittelherstellung und -verarbeitung",
  L1009_L2000_L3000: "Schutz und Reinigung",
  L1009_L2001_L3000: "Schutz-, Sicherheits- und Überwachungsberufe",
  L1009_L2002_L3000: "Reinigungsberufe",
  L1010_L2000_L3000: "Soziales, Lehre und Erziehung",
  L1010_L2001_L3000: "Erziehung, soziale und hauswirtschaftliche Berufe, Theologie",
  L1010_L2002_L3000: "Lehrende und ausbildende Berufe",
  L1011_L2000_L3000: "Technische Berufe",
  L1011_L2001_L3000: "Maschinen- und Fahrzeugtechnikberufe",
  L1011_L2002_L3000: "Mechatronik-, Energie- und Elektroberufe",
  L1011_L2003_L3000:
    "Technische Forschungs-, Entwicklungs-, Konstruktions- und Produktionssteuerungsberufe",
  L1012_L2000_L3000: "Tourismus-, Hotel- und Gaststättenberufe",
  L1012_L2001_L3000: "Tourismus-, Hotel- und Gaststättenberufe",
  L1013_L2000_L3000: "Traditional and New Media Jobs",
  L1013_L2001_L3000: "Werbung, Marketing, kaufmännische und redaktionelle Medienberufe",
  L1013_L2002_L3000:
    "Produktdesign und kunsthandwerkliche Berufe, bildende Kunst, Musikinstrumentenbau",
  L1014_L2000_L3000: "Unternehmensorganisation, Recht und Verwaltung",
  L1014_L2001_L3000: "Berufe in Unternehmensführung und -organisation",
  L1014_L2002_L3000: "Berufe in Recht und Verwaltung",
  L1015_L2000_L3000: "Vertrieb, Verkauf und Einkauf",
  L1015_L2001_L3000: "Einkaufs-, Vertriebs- und Handelsberufe",
  L1015_L2002_L3000: "Verkaufsberufe",
  L1016_L2000_L3000: "Wissenschaftliche Berufe",
  L1016_L2001_L3000: "Mathematik-, Biologie-, Chemie- und Physikberufe",
  L1016_L2002_L3000: "Geologie-, Geografie- und Umweltschutzberufe",
  L1016_L2003_L3000:
    "Sprach-, literatur-, geistes-, gesellschafts- und wirtschaftswissenschaftliche Berufe",

  L1002_L2001_L3001: "Bauplanung und -überwachung, Architektur",
  L1002_L2001_L3002: "Vermessung und Kartografie",
  L1002_L2002_L3001: "Hochbau",
  L1002_L2002_L3002: "Tiefbau",
  L1002_L2003_L3001: "Bodenverlegung",
  L1002_L2003_L3002:
    "Maler- und Lackierer-, Stuckateurarbeiten, Bauwerksabdichtung, Holz- und Bautenschutz",
  L1002_L2003_L3003:
    "Aus- und Trockenbau, Isolierung, Zimmerei, Glaserei, Rollladen- und Jalousiebau",
  L1002_L2004_L3001: "Gebäudetechnik",
  L1002_L2004_L3002: "Klempnerei, Sanitär-, Heizungs- und Klimatechnik",
  L1002_L2004_L3003: "Ver- und Entsorgung",
  L1003_L2001_L3001: "Versicherungs- und Finanzdienstleistungen",
  L1003_L2001_L3002: "Rechnungswesen, Controlling und Revision",
  L1003_L2001_L3003: "Steuerberatung",
  L1004_L2001_L3001: "Arzt- und Praxishilfe",
  L1004_L2001_L3002: "Medizinisches Laboratorium",
  L1004_L2001_L3003: "Gesundheits- und Krankenpflege, Rettungsdienst und Geburtshilfe",
  L1004_L2001_L3004: "Human- und Zahnmedizin",
  L1004_L2001_L3005: "Tiermedizin und Tierheilkunde",
  L1004_L2001_L3006: "Psychologie und nicht ärztliche Psychotherapie",
  L1004_L2001_L3007: "Nicht ärztliche Therapie und Heilkunde",
  L1004_L2001_L3008: "Pharmazie",
  L1004_L2002_L3001: "Altenpflege",
  L1004_L2002_L3002: "Ernährungs- und Gesundheitsberatung, Wellness",
  L1004_L2002_L3003: "Körperpflege",
  L1004_L2002_L3004: "Bestattungswesen",
  L1004_L2002_L3005: "Medizin-, Orthopädie- und Rehatechnik",
  L1005_L2001_L3001: "Informatik",
  L1005_L2001_L3002: "IT-Systemanalyse, IT-Anwendungsberatung und IT-Vertrieb",
  L1005_L2001_L3003: "IT-Netzwerktechnik, IT-Koordination, IT-Administration und IT-Organisation",
  L1005_L2001_L3004: "Softwareentwicklung und Programmierung",
  L1006_L2001_L3001: "Landwirtschaft",
  L1006_L2001_L3002: "Tierwirtschaft",
  L1006_L2001_L3003: "Pferdewirtschaft",
  L1006_L2001_L3004: "Fischwirtschaft",
  L1006_L2001_L3005: "Tierpflege",
  L1006_L2001_L3006: "Weinbau",
  L1006_L2001_L3007: "Forst- und Jagdwirtschaft, Landschaftspflege",
  L1006_L2002_L3001: "Gartenbau",
  L1006_L2002_L3002: "Floristik",
  L1007_L2001_L3001: "Technischer Betrieb des Eisenbahn-, Luft- und Schiffsverkehrs",
  L1007_L2001_L3002: "Überwachung und Wartung der Verkehrsinfrastruktur",
  L1007_L2001_L3003: "Lagerwirtschaft, Post und Zustellung, Güterumschlag",
  L1007_L2001_L3004: "Servicekräfte im Personenverkehr",
  L1007_L2001_L3005: "Überwachung und Steuerung des Verkehrsbetriebs",
  L1007_L2001_L3006: "Kaufleute - Verkehr und Logistik",
  L1007_L2002_L3001: "Fahrzeugführung im Straßenverkehr",
  L1007_L2002_L3002: "Fahrzeugführung im Eisenbahnverkehr",
  L1007_L2002_L3003: "Fahrzeugführung im Flugverkehr",
  L1007_L2002_L3004: "Fahrzeugführung im Schiffsverkehr",
  L1007_L2002_L3005: "Bau- und Transportgeräteführung",
  L1008_L2001_L3001: "Berg-, Tagebau und Sprengtechnik",
  L1008_L2001_L3002:
    "Naturstein- und Mineralaufbereitung und -verarbeitung und Baustoffherstellung",
  L1008_L2001_L3003: "Industrielle Glasherstellung und -verarbeitung",
  L1008_L2001_L3004: "Industrielle Keramikherstellung und -verarbeitung",
  L1008_L2002_L3001: "Kunststoff- und Kautschukherstellung und -verarbeitung",
  L1008_L2002_L3002: "Farb- und Lacktechnik",
  L1008_L2002_L3003: "Holzbe- und -verarbeitung",
  L1008_L2003_L3001: "Papier- und Verpackungstechnik",
  L1008_L2003_L3002: "Technische Mediengestaltung",
  L1008_L2003_L3003: "Fototechnik und Fotografie",
  L1008_L2003_L3004: "Drucktechnik und -weiterverarbeitung, Buchbinderei",
  L1008_L2004_L3001: "Metallerzeugung",
  L1008_L2004_L3002: "Metallbearbeitung",
  L1008_L2004_L3003: "Metalloberflächenbehandlung",
  L1008_L2004_L3004: "Metallbau und Schweißtechnik",
  L1008_L2004_L3005: "Feinwerk- und Werkzeugtechnik",
  L1008_L2005_L3001: "Textiltechnik und -produktion",
  L1008_L2005_L3002: "Textilverarbeitung",
  L1008_L2005_L3003: "Leder-, Pelzherstellung und -verarbeitung",
  L1008_L2006_L3001: "Getränkeherstellung",
  L1008_L2006_L3002: "Lebensmittel- und Genussmittelherstellung",
  L1008_L2006_L3003: "Speisenzubereitung",
  L1009_L2001_L3001: "Objekt-, Personen-, Brandschutz, Arbeitssicherheit",
  L1009_L2001_L3002: "Polizeivollzugs- und Kriminaldienst, Gerichts- und Justizvollzug",
  L1009_L2001_L3003: "Gewerbe- und Gesundheitsaufsicht, Desinfektion",
  L1009_L2002_L3001: "Reinigung",
  L1010_L2001_L3001: "Erziehung, Sozialarbeit, Heilerziehungspflege",
  L1010_L2001_L3002: "Hauswirtschaft und Verbraucherberatung",
  L1010_L2001_L3003: "Theologie und Gemeindearbeit",
  L1010_L2002_L3001: "Lehrtätigkeit an allgemeinbildenden Schulen",
  L1010_L2002_L3002:
    "Lehrtätigkeit für berufsbildende Fächer, betriebliche Ausbildung und Betriebspädagogik",
  L1010_L2002_L3003: "Lehr- und Forschungstätigkeit an Hochschulen",
  L1010_L2002_L3004: "Lehrtätigkeit an außerschulischen Bildungseinrichtungen",
  L1010_L2002_L3005: "Fahr- und Sportunterricht an außerschulischen Bildungseinrichtungen",
  L1011_L2001_L3001: "Maschinenbau- und Betriebstechnik",
  L1011_L2001_L3002: "Fahrzeug-, Luft-, Raumfahrt- und Schiffbautechnik",
  L1011_L2002_L3001: "Mechatronik und Automatisierungstechnik",
  L1011_L2002_L3002: "Energietechnik",
  L1011_L2002_L3003: "Elektrotechnik",
  L1011_L2003_L3001: "Technische Forschung und Entwicklung",
  L1011_L2003_L3002: "Technisches Zeichnen, Konstruktion und Modellbau",
  L1011_L2003_L3003: "Technische Produktionsplanung und -steuerung",
  L1012_L2000_L3001: "Tourismus und Sport",
  L1012_L2000_L3002: "Hotellerie",
  L1012_L2000_L3003: "Gastronomie",
  L1012_L2000_L3004: "Veranstaltungsservice und -management",
  L1013_L2001_L3001: "Werbung und Marketing",
  L1013_L2001_L3002: "Öffentlichkeitsarbeit",
  L1013_L2001_L3003: "Verlags- und Medienwirtschaft",
  L1013_L2001_L3004: "Redaktion und Journalismus",
  L1013_L2002_L3001: "Produkt- und Industriedesign",
  L1013_L2002_L3002: "Innenarchitektur, visuelles Marketing, Raumausstattung",
  L1013_L2002_L3003: "Kunsthandwerk und bildende Kunst",
  L1013_L2002_L3004: "Kunsthandwerkliche Keramik- und Glasgestaltung",
  L1013_L2002_L3005: "Kunsthandwerkliche Metallgestaltung",
  L1013_L2002_L3006: "Musikinstrumentenbau",
  L1014_L2001_L3001: "Geschäftsführung und Vorstand",
  L1014_L2001_L3002:
    "Angehörige gesetzgebender Körperschaften und leitende Bedienstete von Interessenorganisationen",
  L1014_L2001_L3003: "Unternehmensorganisation und -strategie",
  L1014_L2001_L3004: "Büro- und Sekretariat",
  L1014_L2001_L3005: "Personalwesen und -dienstleistung",
  L1014_L2002_L3001: "Rechtsberatung, -sprechung und -ordnung",
  L1014_L2002_L3002: "Verwaltung",
  L1014_L2002_L3003: "Medien-, Dokumentations- und Informationsdienste",
  L1015_L2001_L3001: "Einkauf und Vertrieb",
  L1015_L2001_L3002: "Handel",
  L1015_L2001_L3003: "Immobilienwirtschaft und Facility-Management",
  L1015_L2002_L3001: "Verkauf (ohne Produktspezialisierung)",
  L1015_L2002_L3002: "Verkauf von Bekleidung, Elektronik, Kraftfahrzeugen und Hartwaren",
  L1015_L2002_L3003: "Verkauf von Lebensmitteln",
  L1015_L2002_L3004:
    "Verkauf von drogerie- und apothekenüblichen Waren, Sanitäts- und Medizinbedarf",
  L1015_L2002_L3005: "Buch-, Kunst-, Antiquitäten- und Musikfachhandel",
  L1016_L2001_L3001: "Mathematik und Statistik",
  L1016_L2001_L3002: "Biologie",
  L1016_L2001_L3003: "Chemie",
  L1016_L2001_L3004: "Physik",
  L1016_L2002_L3001: "Geologie, Geografie und Meteorologie",
  L1016_L2002_L3002: "Umweltschutztechnik",
  L1016_L2002_L3003: "Umweltmanagement und -beratung",
  L1016_L2003_L3001: "Sprach- und Literaturwissenschaften",
  L1016_L2003_L3002: "Geisteswissenschaften",
  L1016_L2003_L3003: "Gesellschaftswissenschaften",
  L1016_L2003_L3004: "Wirtschaftswissenschaften",

  L1012_L2001_L3001: "Tourismus und Sport",
  L1012_L2001_L3002: "Hotellerie",
  L1012_L2001_L3003: "Gastronomie",
  L1012_L2001_L3004: "Veranstaltungsservice und -management",

  L1000_L2001_L3001: "Musik-, Gesangs- und Dirigententätigkeiten",
  L1000_L2001_L3002: "Schauspiel, Tanz und Bewegungskunst",
  L1000_L2001_L3003: "Moderation und Unterhaltung",
  L1000_L2001_L3004: "Theater-, Film- und Fernsehproduktion",
  L1000_L2001_L3005: "Veranstaltungs-, Kamera- und Tontechnik",
  L1000_L2001_L3006: "Bühnen- und Kostümbildnerei, Requisite",
  L1000_L2001_L3007: "Museumstechnik und -management",

  // LEVEL 4
  L1006_L2001_L3001_L4001: "Berufe in der Landwirtschaft (ohne Spezialisierung)",
  L1006_L2001_L3001_L4002: "Berufe in der Landtechnik",
  L1006_L2001_L3001_L4003: "Landwirtschaftliche Sachverständige",
  L1006_L2001_L3001_L4004: "Berufe im landwirtschaftlich-technischen Laboratorium",
  L1006_L2001_L3001_L4005: "Berufe in der Landwirtschaft (sonstige spezifische Tätigkeitsangabe)",
  L1006_L2001_L3001_L4006: "Aufsichts- und Führungskräfte - Landwirtschaft",
  L1006_L2001_L3002_L4001: "Berufe in der Nutztierhaltung (außer Geflügelhaltung)",
  L1006_L2001_L3002_L4002: "Berufe in der Geflügelhaltung",
  L1006_L2001_L3002_L4003: "Berufe in der Imkerei",
  L1006_L2001_L3002_L4004: "Berufe in der Tierwirtschaft (sonstige spezifische Tätigkeitsangabe)",
  L1006_L2001_L3002_L4005: "Aufsichts- und Führungskräfte - Tierwirtschaft",
  L1006_L2001_L3003_L4001: "Berufe in der Pferdewirtschaft (ohne Spezialisierung)",
  L1006_L2001_L3003_L4002: "Berufe in der Pferdewirtschaft - Pferdezucht",
  L1006_L2001_L3003_L4003: "Berufe in der Pferdewirtschaft - Reiten",
  L1006_L2001_L3003_L4004: "Hufbeschlagschmiede/-schmiedinnen",
  L1006_L2001_L3003_L4005: "Kutscher/innen",
  L1006_L2001_L3003_L4006: "Aufsichts- und Führungskräfte - Pferdewirtschaft",
  L1006_L2001_L3004_L4001: "Berufe in der Fischwirtschaft (ohne Spezialisierung)",
  L1006_L2001_L3004_L4002: "Berufe in der Fischzucht",
  L1006_L2001_L3004_L4003: "Berufe in der Fischerei",
  L1006_L2001_L3004_L4004: "Aufsichts- und Führungskräfte - Fischwirtschaft",
  L1006_L2001_L3005_L4001: "Berufe in der Tierpflege (ohne Spezialisierung)",
  L1006_L2001_L3005_L4002: "Berufe in der Nutztierpflege",
  L1006_L2001_L3005_L4003: "Berufe in der Haus- und Zootierpflege",
  L1006_L2001_L3005_L4004: "Berufe in der Tierpflege (sonstige spezifische Tätigkeitsangabe)",
  L1006_L2001_L3005_L4005: "Aufsichts- und Führungskräfte - Tierpflege",
  L1006_L2001_L3006_L4001: "Berufe im Weinbau",
  L1006_L2001_L3006_L4002: "Aufsichts- und Führungskräfte - Weinbau",
  L1006_L2001_L3007_L4001: "Berufe in der Forstwirtschaft",
  L1006_L2001_L3007_L4002: "Berufe in der Natur- und Landschaftspflege",
  L1006_L2001_L3007_L4003: "Berufe in der Jagdwirtschaft und Wildhege",
  L1006_L2001_L3007_L4004: "Sammeln und Gewinnen von Pflanzen und anderen Naturprodukten",
  L1006_L2001_L3007_L4005:
    "Aufsichts- und Führungskräfte - Forst- und Jagdwirtschaft, Landschaftspflege",
  L1006_L2002_L3001_L4001: "Berufe im Gartenbau (ohne Spezialisierung)",
  L1006_L2002_L3001_L4002: "Berufe im Obst- und Gemüsebau",
  L1006_L2002_L3001_L4003: "Berufe in Baumschule, Staudengärtnerei und Zierpflanzenbau",
  L1006_L2002_L3001_L4004: "Berufe in der Friedhofsgärtnerei",
  L1006_L2002_L3001_L4005: "Berufe im Garten-, Landschafts- und Sportplatzbau",
  L1006_L2002_L3001_L4006: "Aufsichts- und Führungskräfte - Gartenbau",
  L1006_L2002_L3002_L4001: "Berufe in der Floristik",
  L1006_L2002_L3002_L4002: "Aufsichts- und Führungskräfte - Floristik",
  L1008_L2001_L3001_L4001: "Berufe im Berg- und Tagebau",
  L1008_L2001_L3001_L4002: "Berufe in der Sprengtechnik",
  L1008_L2001_L3001_L4003: "Aufsichts- und Führungskräfte - Berg- und Tagebau und Sprengtechnik",
  L1008_L2001_L3002_L4001:
    "Berufe in der Naturstein- und Mineralaufbereitung und -verarbeitung und Baustoffherstellung (ohne Spezialisierung)",
  L1008_L2001_L3002_L4002: "Berufe in der Naturstein- und Mineralaufbereitung",
  L1008_L2001_L3002_L4003: "Berufe in der Baustoffherstellung",
  L1008_L2001_L3002_L4004: "Berufe in der Steinmetztechnik",
  L1008_L2001_L3002_L4005:
    "Aufsichtskräfte - Naturstein- und Mineralaufbereitung und -verarbeitung und Baustoffherstellung",
  L1008_L2001_L3003_L4001: "Berufe in der Glasherstellung",
  L1008_L2001_L3003_L4002: "Berufe im Glasapparatebau",
  L1008_L2001_L3003_L4003: "Berufe in der industriellen Glasbläserei",
  L1008_L2001_L3003_L4004: "Berufe in der Glasveredelung",
  L1008_L2001_L3003_L4005: "Berufe in der Glasapparatejustierung",
  L1008_L2001_L3003_L4006: "Berufe in der Feinoptik",
  L1008_L2001_L3003_L4007: "Aufsichtskräfte - Industrielle Glasherstellung und -verarbeitung",
  L1008_L2001_L3004_L4001: "Berufe in der Industriekeramik (Verfahrens- und Anlagentechnik)",
  L1008_L2001_L3004_L4002: "Berufe in der Industriekeramik (Modelltechnik)",
  L1008_L2001_L3004_L4003: "Aufsichtskräfte - Industrielle Keramikherstellung und -verarbeitung",
  L1008_L2002_L3001_L4001:
    "Berufe in der Kunststoff- und Kautschukherstellung (ohne Spezialisierung)",
  L1008_L2002_L3001_L4002: "Berufe in der Reifen- und Vulkanisationstechnik",
  L1008_L2002_L3001_L4003:
    "Berufe in der Kunststoff- und Kautschukherstellung und -verarbeitung (sonstige spezifische Tätigkeitsangabe)",
  L1008_L2002_L3001_L4004:
    "Aufsichtskräfte - Kunststoff- und Kautschukherstellung und -verarbeitung",
  L1008_L2002_L3002_L4001: "Berufe in der Farb- und Lacktechnik (ohne Spezialisierung)",
  L1008_L2002_L3002_L4002: "Berufe in der Fahrzeuglackierung",
  L1008_L2002_L3002_L4003: "Berufe im Lacklaboratorium",
  L1008_L2002_L3002_L4004: "Aufsichtskräfte - Farb- und Lacktechnik",
  L1008_L2002_L3003_L4001: "Berufe in der Holzbe- und -verarbeitung (ohne Spezialisierung)",
  L1008_L2002_L3003_L4002: "Berufe in der Holztrocknung und -konservierung",
  L1008_L2002_L3003_L4003: "Berufe in der Produktion von Holzwerkstoffen und -bauteilen",
  L1008_L2002_L3003_L4004:
    "Berufe in der Produktion von Fertigprodukten aus Holz und Holzwerkstoffen",
  L1008_L2002_L3003_L4005: "Berufe im Holz-, Möbel- und Innenausbau",
  L1008_L2002_L3003_L4006: "Flechtwerkgestalter/innen, Bürsten- und Pinselmacher/innen",
  L1008_L2002_L3003_L4007:
    "Berufe in der Holzbe- und -verarbeitung (sonstige spezifische Tätigkeitsangabe)",
  L1008_L2002_L3003_L4008: "Aufsichts- und Führungskräfte - Holzbe- und -verarbeitung",
  L1008_L2003_L3001_L4001: "Berufe in der Papier- und Verpackungstechnik (ohne Spezialisierung)",
  L1008_L2003_L3001_L4002: "Berufe in der Papierherstellung",
  L1008_L2003_L3001_L4003: "Berufe in der Papierverarbeitung und Verpackungstechnik",
  L1008_L2003_L3001_L4004: "Aufsichtskräfte - Papier- und Verpackungstechnik",
  L1008_L2003_L3002_L4001: "Berufe in der Digital- und Printmediengestaltung",
  L1008_L2003_L3002_L4002: "Berufe im Grafik-, Kommunikations- und Fotodesign",
  L1008_L2003_L3002_L4003:
    "Berufe in der technischen Mediengestaltung (sonstige spezifische Tätigkeitsangabe)",
  L1008_L2003_L3002_L4004: "Aufsichts- und Führungskräfte - Technische Mediengestaltung",
  L1008_L2003_L3003_L4001: "Berufe in der Fototechnik",
  L1008_L2003_L3003_L4002: "Berufe in der Fotografie",
  L1008_L2003_L3003_L4003: "Aufsichtskräfte - Fototechnik und Fotografie",
  L1008_L2003_L3004_L4001: "Berufe in der Drucktechnik",
  L1008_L2003_L3004_L4002: "Berufe in der Buchbinderei und Druckweiterverarbeitung",
  L1008_L2003_L3004_L4003: "Aufsichtskräfte - Drucktechnik und -weiterverarbeitung, Buchbinderei",
  L1008_L2004_L3001_L4001: "Berufe in der Metallerzeugung (ohne Spezialisierung)",
  L1008_L2004_L3001_L4002: "Berufe in der Hüttentechnik",
  L1008_L2004_L3001_L4003: "Berufe in der Metallumformung",
  L1008_L2004_L3001_L4004: "Berufe in der industriellen Gießerei",
  L1008_L2004_L3001_L4005: "Berufe in der handwerklichen Metall- und Glockengießerei",
  L1008_L2004_L3001_L4006: "Aufsichtskräfte - Metallerzeugung",
  L1008_L2004_L3002_L4001: "Berufe in der Metallbearbeitung (ohne Spezialisierung)",
  L1008_L2004_L3002_L4002: "Berufe in der spanlosen Metallbearbeitung",
  L1008_L2004_L3002_L4003: "Berufe in der schleifenden Metallbearbeitung",
  L1008_L2004_L3002_L4004: "Berufe in der spanenden Metallbearbeitung",
  L1008_L2004_L3002_L4005: "Berufe in der Metallbearbeitung durch Laserstrahl",
  L1008_L2004_L3002_L4006: "Aufsichtskräfte - Metallbearbeitung",
  L1008_L2004_L3003_L4001: "Berufe in der Metalloberflächenbehandlung (ohne Spezialisierung)",
  L1008_L2004_L3003_L4002:
    "Berufe in der Metalloberflächenbehandlung (sonstige spezifische Tätigkeitsangabe)",
  L1008_L2004_L3003_L4003: "Aufsichtskräfte - Metalloberflächenbehandlung",
  L1008_L2004_L3004_L4001: "Berufe im Metallbau",
  L1008_L2004_L3004_L4002: "Berufe in der Schweiß- und Verbindungstechnik",
  L1008_L2004_L3004_L4003: "Industrietaucher/innen und andere Taucherberufe",
  L1008_L2004_L3004_L4004: "Aufsichtskräfte - Metallbau und Schweißtechnik",
  L1008_L2004_L3005_L4001: "Berufe in der Feinwerktechnik",
  L1008_L2004_L3005_L4002: "Berufe in der Werkzeugtechnik",
  L1008_L2004_L3005_L4003: "Berufe im Uhrmacherhandwerk",
  L1008_L2004_L3005_L4004: "Aufsichtskräfte - Feinwerk- und Werkzeugtechnik",
  L1011_L2001_L3001_L4001: "Berufe in der Maschinenbau- und Betriebstechnik (ohne Spezialisierung)",
  L1011_L2001_L3001_L4002: "Maschinen- und Gerätezusammensetzer/innen",
  L1011_L2001_L3001_L4003: "Maschinen- und Anlagenführer/innen",
  L1011_L2001_L3001_L4004: "Technische Servicekräfte in Wartung und Instandhaltung",
  L1011_L2001_L3001_L4005:
    "Berufe in der Maschinenbau- und Betriebstechnik (sonstige spezifische Tätigkeitsangabe)",
  L1011_L2001_L3001_L4006: "Aufsichts- und Führungskräfte - Maschinenbau- und Betriebstechnik",
  L1011_L2001_L3002_L4001: "Berufe in der Fahrzeugtechnik (ohne Spezialisierung)",
  L1011_L2001_L3002_L4002: "Berufe in der Kraftfahrzeugtechnik",
  L1011_L2001_L3002_L4003: "Berufe in der Land- und Baumaschinentechnik",
  L1011_L2001_L3002_L4004: "Berufe in der Luft- und Raumfahrttechnik",
  L1011_L2001_L3002_L4005: "Berufe in der Schiffbautechnik",
  L1011_L2001_L3002_L4006: "Berufe in der Zweiradtechnik",
  L1011_L2001_L3002_L4007:
    "Aufsichts- und Führungskräfte - Fahrzeug-, Luft-, Raumfahrt- und Schiffbautechnik",
  L1011_L2002_L3001_L4001: "Berufe in der Mechatronik",
  L1011_L2002_L3001_L4002: "Berufe in der Automatisierungstechnik",
  L1011_L2002_L3001_L4003: "Aufsichtskräfte - Mechatronik und Automatisierungstechnik",
  L1011_L2002_L3002_L4001: "Berufe in der Bauelektrik",
  L1011_L2002_L3002_L4002: "Berufe in der Elektromaschinentechnik",
  L1011_L2002_L3002_L4003: "Berufe in der Energie- und Kraftwerkstechnik",
  L1011_L2002_L3002_L4004: "Berufe in der regenerativen Energietechnik",
  L1011_L2002_L3002_L4005: "Berufe in der elektrischen Betriebstechnik",
  L1011_L2002_L3002_L4006: "Berufe in der Leitungsinstallation und -wartung",
  L1011_L2002_L3002_L4007: "Aufsichtskräfte - Energietechnik",
  L1011_L2002_L3003_L4001: "Berufe in der Elektrotechnik (ohne Spezialisierung)",
  L1011_L2002_L3003_L4002: "Berufe in der Informations- und Telekommunikationstechnik",
  L1011_L2002_L3003_L4003: "Berufe in der Mikrosystemtechnik",
  L1011_L2002_L3003_L4004: "Berufe in der Luftverkehrs-, Schiffs- und Fahrzeugelektronik",
  L1011_L2002_L3003_L4005: "Berufe in der Elektrotechnik (sonstige spezifische Tätigkeitsangabe)",
  L1011_L2002_L3003_L4006: "Aufsichtskräfte - Elektrotechnik",
  L1011_L2003_L3001_L4001:
    "Berufe in der technischen Forschung und Entwicklung (ohne Spezialisierung)",
  L1011_L2003_L3001_L4002:
    "Berufe in der technischen Forschung und Entwicklung (sonstige spezifische Tätigkeitsangabe)",
  L1011_L2003_L3001_L4003: "Führungskräfte - Technische Forschung und Entwicklung",
  L1011_L2003_L3002_L4001: "Technische Zeichner/innen",
  L1011_L2003_L3002_L4002: "Berufe in der Konstruktion und im Gerätebau",
  L1011_L2003_L3002_L4003: "Berufe im Modellbau",
  L1011_L2003_L3002_L4004:
    "Technisches Zeichnen, Konstruktion und Modellbau (sonstige spezifische Tätigkeitsangabe)",
  L1011_L2003_L3002_L4005:
    "Aufsichts- und Führungskräfte - Technisches Zeichnen, Konstruktion und Modellbau",
  L1011_L2003_L3003_L4001: "Berufe in der technischen Produktionsplanung und -steuerung",
  L1011_L2003_L3003_L4002: "Berufe in der technischen Qualitätssicherung",
  L1011_L2003_L3003_L4003:
    "Aufsichts- und Führungskräfte - Technische Produktionsplanung und -steuerung",
  L1008_L2005_L3001_L4001: "Berufe in der Textiltechnik (ohne Spezialisierung)",
  L1008_L2005_L3001_L4002: "Berufe in der Textilgestaltung",
  L1008_L2005_L3001_L4003: "Berufe in der Textilherstellung",
  L1008_L2005_L3001_L4004: "Berufe in der Garn- und Seilherstellung",
  L1008_L2005_L3001_L4005: "Berufe in der Textilveredlung",
  L1008_L2005_L3001_L4006: "Aufsichts- und Führungskräfte - Textiltechnik und -produktion",
  L1008_L2005_L3002_L4001: "Berufe im Modedesign",
  L1008_L2005_L3002_L4002: "Berufe in der Bekleidungs-, Hut- und Mützenherstellung",
  L1008_L2005_L3002_L4003: "Technische Konfektionäre/Konfektionärinnen, Segelmacher/innen",
  L1008_L2005_L3002_L4004: "Berufe in der Polsterei und Fahrzeuginnenausstattung",
  L1008_L2005_L3002_L4005: "Aufsichts- und Führungskräfte - Textilverarbeitung",
  L1008_L2005_L3003_L4001:
    "Berufe in der Leder-, Pelzherstellung und -verarbeitung (ohne Spezialisierung)",
  L1008_L2005_L3003_L4002: "Berufe in der Lederherstellung",
  L1008_L2005_L3003_L4003: "Berufe in der Sattlerei und Herstellung von Lederutensilien",
  L1008_L2005_L3003_L4004: "Berufe in der Schuhherstellung",
  L1008_L2005_L3003_L4005: "Berufe in der Pelzbe- und -verarbeitung",
  L1008_L2005_L3003_L4006:
    "Aufsichts- und Führungskräfte - Leder-, Pelzherstellung und -verarbeitung",
  L1008_L2006_L3001_L4001: "Berufe in der Getränkeherstellung (ohne Spezialisierung)",
  L1008_L2006_L3001_L4002: "Brauer/innen und Mälzer/innen",
  L1008_L2006_L3001_L4003: "Weinküfer/innen",
  L1008_L2006_L3001_L4004: "Brenner/innen und Destillateure/Destillateurinnen",
  L1008_L2006_L3001_L4005: "Berufe in der Fruchtsafttechnik",
  L1008_L2006_L3001_L4006: "Nahrungsmittel- und Getränkekoster/innen",
  L1008_L2006_L3001_L4007: "Aufsichts- und Führungskräfte - Getränkeherstellung",
  L1008_L2006_L3002_L4001: "Berufe in der Lebensmittelherstellung (ohne Spezialisierung)",
  L1008_L2006_L3002_L4002: "Berufe in der Mühlenprodukt- und Futtermittelherstellung",
  L1008_L2006_L3002_L4003: "Berufe in der Back- und Konditoreiwarenherstellung",
  L1008_L2006_L3002_L4004: "Berufe in der Fleischverarbeitung",
  L1008_L2006_L3002_L4005: "Berufe in der Fischverarbeitung",
  L1008_L2006_L3002_L4006: "Berufe in der Milchproduktherstellung",
  L1008_L2006_L3002_L4007: "Berufe in der Süßwarenherstellung",
  L1008_L2006_L3002_L4008: "Berufe in der Tabakwarenherstellung",
  L1008_L2006_L3002_L4009:
    "Berufe in der Lebensmittelherstellung (sonstige spezifische Tätigkeitsangabe)",
  L1008_L2006_L3002_L4010:
    "Aufsichts- und Führungskräfte - Lebensmittel- und Genussmittelherstellung",
  L1008_L2006_L3003_L4001: "Köche/Köchinnen (ohne Spezialisierung)",
  L1008_L2006_L3003_L4002: "Vor-, Kalt- und Süßspeisenköche/-köchinnen",
  L1008_L2006_L3003_L4003: "Grill-, Braten- und Fischköche/-köchinnen",
  L1008_L2006_L3003_L4004: "Köche/Köchinnen (sonstige spezifische Tätigkeitsangabe)",
  L1008_L2006_L3003_L4005: "Aufsichts- und Führungskräfte - Speisenzubereitung",
  L1002_L2001_L3001_L4001: "Berufe in der Bauplanung und -überwachung (ohne Spezialisierung)",
  L1002_L2001_L3001_L4002: "Berufe in der Architektur",
  L1002_L2001_L3001_L4003: "Berufe in der Stadt- und Raumplanung",
  L1002_L2001_L3001_L4004: "Berufe in der Bauplanung von Verkehrswegen und -anlagen",
  L1002_L2001_L3001_L4005: "Berufe in der Wasserwirtschaft",
  L1002_L2001_L3001_L4006: "Berufe in der Bauwerkserhaltung und -erneuerung",
  L1002_L2001_L3001_L4007: "Bausachverständige und Baukontrolleure/-kontrolleurinnen",
  L1002_L2001_L3001_L4008: "Berufe in der Bauabrechnung und -kalkulation",
  L1002_L2001_L3001_L4009:
    "Aufsichts- und Führungskräfte - Bauplanung und -überwachung, Architektur",
  L1002_L2001_L3002_L4001: "Berufe in der Vermessungstechnik",
  L1002_L2001_L3002_L4002: "Berufe in der Kartografie",
  L1002_L2002_L3001_L4001: "Berufe im Hochbau (ohne Spezialisierung)",
  L1002_L2002_L3001_L4002: "Berufe im Beton- und Stahlbetonbau",
  L1002_L2002_L3001_L4003: "Berufe im Maurerhandwerk",
  L1002_L2002_L3001_L4004: "Berufe im Schornsteinbau",
  L1002_L2002_L3001_L4005: "Berufe in der Dachdeckerei",
  L1002_L2002_L3001_L4006: "Berufe im Fassadenbau",
  L1002_L2002_L3001_L4007: "Berufe im Gerüstbau",
  L1002_L2002_L3001_L4008: "Berufe im Bauwerksabbruch",
  L1002_L2002_L3001_L4009: "Aufsichtskräfte - Hochbau",
  L1002_L2002_L3002_L4001: "Berufe im Tiefbau (ohne Spezialisierung)",
  L1002_L2002_L3002_L4002: "Pflasterer/Pflasterinnen und Steinsetzer/innen",
  L1002_L2002_L3002_L4003: "Berufe im Straßen- und Asphaltbau",
  L1002_L2002_L3002_L4004: "Berufe im Gleisbau",
  L1002_L2002_L3002_L4005: "Berufe im Brunnenbau",
  L1002_L2002_L3002_L4006: "Berufe im Kanal- und Tunnelbau",
  L1002_L2002_L3002_L4007: "Berufe im Kultur- und Wasserbau",
  L1002_L2002_L3002_L4008: "Aufsichtskräfte - Tiefbau",
  L1002_L2003_L3001_L4001: "Berufe in der Bodenverlegung (ohne Spezialisierung)",
  L1002_L2003_L3001_L4002: "Berufe in der Fliesen-, Platten- und Mosaikverlegung",
  L1002_L2003_L3001_L4003: "Berufe in der Estrich- und Terrazzoverlegung",
  L1002_L2003_L3001_L4004: "Berufe in der Parkettverlegung",
  L1002_L2003_L3001_L4005: "Aufsichtskräfte - Bodenverlegung",
  L1002_L2003_L3002_L4001: "Berufe für Maler- und Lackiererarbeiten",
  L1002_L2003_L3002_L4002: "Berufe für Stuckateurarbeiten",
  L1002_L2003_L3002_L4003: "Berufe in der Bauwerksabdichtung",
  L1002_L2003_L3002_L4004: "Berufe im Holz- und Bautenschutz",
  L1002_L2003_L3002_L4005:
    "Aufsichtskräfte - Maler- und Lackierer-, Stuckateurarbeiten, Bauwerksabdichtung, Holz- und Bautenschutz",
  L1002_L2003_L3003_L4001: "Berufe im Aus- und Trockenbau (ohne Spezialisierung)",
  L1002_L2003_L3003_L4002: "Berufe in der Isolierung",
  L1002_L2003_L3003_L4003: "Berufe in der Zimmerei",
  L1002_L2003_L3003_L4004: "Berufe in der Bautischlerei",
  L1002_L2003_L3003_L4005: "Berufe in der Glaserei",
  L1002_L2003_L3003_L4006: "Berufe im Rollladen- und Jalousiebau",
  L1002_L2003_L3003_L4007:
    "Aufsichtskräfte - Aus- und Trockenbau, Isolierung, Zimmerei, Glaserei, Rollladen- und Jalousiebau",
  L1002_L2004_L3001_L4001: "Berufe in der Gebäudetechnik (ohne Spezialisierung)",
  L1002_L2004_L3001_L4002: "Platz- und Gerätewarte/-wartinnen",
  L1002_L2004_L3001_L4003: "Aufsichtskräfte - Gebäudetechnik",
  L1002_L2004_L3002_L4001: "Berufe in der Klempnerei (ohne Spezialisierung)",
  L1002_L2004_L3002_L4002: "Berufe in der Sanitär-, Heizungs- und Klimatechnik",
  L1002_L2004_L3002_L4003: "Berufe im Ofen- und Luftheizungsbau",
  L1002_L2004_L3002_L4004: "Berufe in der Kältetechnik",
  L1002_L2004_L3002_L4005: "Aufsichtskräfte - Klempnerei, Sanitär-, Heizungs- und Klimatechnik",
  L1002_L2004_L3003_L4001: "Berufe in der Ver- und Entsorgung (ohne Spezialisierung)",
  L1002_L2004_L3003_L4002: "Berufe in der Wasserversorgungs- und Abwassertechnik",
  L1002_L2004_L3003_L4003: "Berufe im Rohrleitungsbau",
  L1002_L2004_L3003_L4004: "Berufe in der Abfallwirtschaft",
  L1002_L2004_L3003_L4005: "Berufe im Anlagen-, Behälter- und Apparatebau",
  L1002_L2004_L3003_L4006: "Aufsichtskräfte - Ver- und Entsorgung",
  L1016_L2001_L3001_L4001: "Berufe in der Mathematik (ohne Spezialisierung)",
  L1016_L2001_L3001_L4002: "Berufe in der Statistik",
  L1016_L2001_L3001_L4003: "Berufe in der Mathematik (sonstige spezifische Tätigkeitsangabe)",
  L1016_L2001_L3001_L4004: "Führungskräfte - Mathematik und Statistik",
  L1016_L2001_L3002_L4001: "Berufe in der Biologie (ohne Spezialisierung)",
  L1016_L2001_L3002_L4002: "Berufe im biologisch-technischen Laboratorium",
  L1016_L2001_L3002_L4003: "Berufe in der biologischen Präparation",
  L1016_L2001_L3002_L4004: "Berufe in der Biologie (Ökologie)",
  L1016_L2001_L3002_L4005: "Berufe in der Biologie (Botanik)",
  L1016_L2001_L3002_L4006: "Berufe in der Biologie (Zoologie)",
  L1016_L2001_L3002_L4007: "Berufe in der Biologie (Mikrobiologie)",
  L1016_L2001_L3002_L4008: "Berufe in der Biologie (Humanbiologie)",
  L1016_L2001_L3002_L4009: "Berufe in der Biologie (sonstige spezifische Tätigkeitsangabe)",
  L1016_L2001_L3002_L4010: "Aufsichts- und Führungskräfte - Biologie",
  L1016_L2001_L3003_L4001: "Berufe in der Chemie (ohne Spezialisierung)",
  L1016_L2001_L3003_L4002: "Berufe in der Chemie-und Pharmatechnik",
  L1016_L2001_L3003_L4003: "Berufe im chemisch-technischen Laboratorium",
  L1016_L2001_L3003_L4004: "Steuerer/Steuerinnen von chemischen Verfahrensanlagen",
  L1016_L2001_L3003_L4005: "Steuerer/Steuerinnen von Erdöl- und Erdgasraffinationsanlagen",
  L1016_L2001_L3003_L4006: "Berufe in der Chemie (sonstige spezifische Tätigkeitsangabe)",
  L1016_L2001_L3003_L4007: "Aufsichts- und Führungskräfte - Chemie",
  L1016_L2001_L3004_L4001: "Berufe in der Physik (ohne Spezialisierung)",
  L1016_L2001_L3004_L4002: "Berufe im physikalisch-technischen Laboratorium",
  L1016_L2001_L3004_L4003: "Berufe in der Werkstofftechnik",
  L1016_L2001_L3004_L4004: "Berufe in der Baustoffprüfung",
  L1016_L2001_L3004_L4005: "Berufe in der Physik (sonstige spezifische Tätigkeitsangabe)",
  L1016_L2001_L3004_L4006: "Aufsichts- und Führungskräfte - Physik",
  L1016_L2002_L3001_L4001: "Berufe in der Geotechnik",
  L1016_L2002_L3001_L4002: "Berufe in der Geologie",
  L1016_L2002_L3001_L4003: "Berufe in der Geografie",
  L1016_L2002_L3001_L4004: "Berufe in der Meteorologie",
  L1016_L2002_L3002_L4001: "Berufe in der Umweltschutztechnik (ohne Spezialisierung)",
  L1016_L2002_L3002_L4002: "Schornsteinfeger/innen",
  L1016_L2002_L3002_L4003:
    "Berufe in der Umweltschutztechnik (sonstige spezifische Tätigkeitsangabe)",
  L1016_L2002_L3002_L4004: "Aufsichtskräfte - Umweltschutztechnik",
  L1016_L2002_L3003_L4001: "Berufe in der Umweltschutzverwaltung und -beratung",
  L1016_L2002_L3003_L4002: "Gewässer-, Immissionsschutz- und Abfallbeauftragte",
  L1016_L2002_L3003_L4003: "Strahlenschutzbeauftragte",
  L1016_L2002_L3003_L4004: "Führungskräfte - Umweltmanagement und -beratung",
  L1005_L2001_L3001_L4001: "Berufe in der Informatik (ohne Spezialisierung)",
  L1005_L2001_L3001_L4002: "Berufe in der Wirtschaftsinformatik",
  L1005_L2001_L3001_L4003: "Berufe in der technischen Informatik",
  L1005_L2001_L3001_L4004: "Berufe in der Bio- und Medizininformatik",
  L1005_L2001_L3001_L4005: "Berufe in der Geoinformatik",
  L1005_L2001_L3001_L4006: "Berufe in der Medieninformatik",
  L1005_L2001_L3001_L4007: "Führungskräfte - Informatik",
  L1005_L2001_L3002_L4001: "Berufe in der IT-Systemanalyse",
  L1005_L2001_L3002_L4002: "Berufe in der IT-Anwendungsberatung",
  L1005_L2001_L3002_L4003: "Berufe im IT-Vertrieb",
  L1005_L2001_L3002_L4004:
    "Führungskräfte - IT-Systemanalyse, IT-Anwendungsberatung und IT-Vertrieb",
  L1005_L2001_L3003_L4001: "Berufe in der IT-Netzwerktechnik",
  L1005_L2001_L3003_L4002: "Berufe in der IT-Koordination",
  L1005_L2001_L3003_L4003: "Berufe in der IT-Organisation",
  L1005_L2001_L3003_L4004: "Berufe in der IT-Systemadministation",
  L1005_L2001_L3003_L4005: "Berufe in der Datenbankentwicklung und -administration",
  L1005_L2001_L3003_L4006: "Berufe in der Webadministration",
  L1005_L2001_L3003_L4007:
    "Berufe in der IT-Netzwerktechnik, IT-Koordination, IT-Administration und IT-Organisation (sonstige spezifische Tätigkeitsangabe)",
  L1005_L2001_L3003_L4008:
    "Führungskräfte - IT-Netzwerktechnik, IT-Koordination, IT-Administration und IT-Organisation",
  L1005_L2001_L3004_L4001: "Berufe in der Softwareentwicklung",
  L1005_L2001_L3004_L4002: "Berufe in der Programmierung",
  L1005_L2001_L3004_L4003: "Führungskräfte - Softwareentwicklung und Programmierung",
  L1007_L2001_L3001_L4001: "Berufe im technischen Eisenbahnbetrieb",
  L1007_L2001_L3001_L4002: "Berufe im technischen Luftverkehrsbetrieb",
  L1007_L2001_L3001_L4003: "Berufe im technischen Schiffsverkehrsbetrieb",
  L1007_L2001_L3001_L4004:
    "Berufe im technischen Betrieb des Eisenbahn-, Luft- und Schiffsverkehrs (sonstige spezifische Tätigkeitsangabe)",
  L1007_L2001_L3001_L4005:
    "Aufsichtskräfte - Technischer Betrieb im Eisenbahn-, Luft- und Schiffsverkehr",
  L1007_L2001_L3002_L4001: "Straßen- und Tunnelwärter/innen",
  L1007_L2001_L3002_L4002: "Berufe in der Überwachung und Wartung der Eisenbahninfrastruktur",
  L1007_L2001_L3002_L4003: "Berufe in der Flugsicherungstechnik",
  L1007_L2001_L3002_L4004: "Wasserstraßen- und Brückenwärter/innen",
  L1007_L2001_L3002_L4005: "Aufsichtskräfte - Überwachung und Wartung der Verkehrsinfrastruktur",
  L1007_L2001_L3003_L4001: "Berufe in der Lagerwirtschaft",
  L1007_L2001_L3003_L4002: "Berufe für Post- und Zustelldienste",
  L1007_L2001_L3003_L4003: "Berufe im Güter- und Warenumschlag",
  L1007_L2001_L3003_L4004:
    "Aufsichts- und Führungskräfte - Lagerwirtschaft, Post und Zustellung, Güterumschlag",
  L1007_L2001_L3004_L4001: "Servicefachkräfte im Straßen- und Schienenverkehr",
  L1007_L2001_L3004_L4002: "Servicefachkräfte im Luftverkehr",
  L1007_L2001_L3004_L4003: "Servicefachkräfte im Schiffsverkehr",
  L1007_L2001_L3004_L4004: "Aufsichtskräfte - Personenverkehr (Servicebereich)",
  L1007_L2001_L3005_L4001:
    "Berufe in der Überwachung und Steuerung des Verkehrsbetriebs (ohne Spezialisierung)",
  L1007_L2001_L3005_L4002: "Berufe in der Überwachung und Steuerung des Straßenverkehrsbetriebs",
  L1007_L2001_L3005_L4003: "Berufe in der Überwachung und Steuerung des Eisenbahnverkehrsbetriebs",
  L1007_L2001_L3005_L4004: "Berufe in der Überwachung und Steuerung des Luftverkehrsbetriebs",
  L1007_L2001_L3005_L4005: "Berufe in der Überwachung und Steuerung des Schiffsverkehrsbetriebs",
  L1007_L2001_L3005_L4006:
    "Berufe in der Überwachung und Steuerung des Verkehrsbetriebs (sonstige spezifische Tätigkeitsangabe)",
  L1007_L2001_L3005_L4007:
    "Aufsichts- und Führungskräfte - Überwachung und Steuerung des Verkehrsbetriebs",
  L1007_L2001_L3006_L4001: "Verkehrskaufleute",
  L1007_L2001_L3006_L4002: "Speditions- und Logistikkaufleute",
  L1007_L2001_L3006_L4003: "Straßen- und Schienenverkehrskaufleute",
  L1007_L2001_L3006_L4004: "Luftverkehrskaufleute",
  L1007_L2001_L3006_L4005: "Schifffahrtskaufleute",
  L1007_L2001_L3006_L4006: "Kurier-, Express- und Postdienstleistungskaufleute",
  L1007_L2001_L3006_L4007: "Führungskräfte - Verkehr und Logistik (kaufmännischer Bereich)",
  L1007_L2002_L3001_L4001: "Berufskraftfahrer/innen (Personentransport/PKW)",
  L1007_L2002_L3001_L4002: "Berufskraftfahrer/innen (Güterverkehr/LKW)",
  L1007_L2002_L3001_L4003: "Bus- und Straßenbahnfahrer/innen",
  L1007_L2002_L3001_L4004:
    "Fahrzeugführer/innen im Straßenverkehr (sonstige spezifische Tätigkeitsangabe)",
  L1007_L2002_L3002_L4001: "Triebfahrzeugführer/innen im Eisenbahnverkehr (ohne Spezialisierung)",
  L1007_L2002_L3003_L4001: "Piloten/Pilotinnen und Verkehrsflugzeugführer/innen",
  L1007_L2002_L3003_L4002:
    "Fahrzeugführer/innen im Flugverkehr (sonstige spezifische Tätigkeitsangabe)",
  L1007_L2002_L3004_L4001: "Nautische Schiffsoffiziere/-offizierinnen und Kapitäne/Kapitäninnen",
  L1007_L2002_L3004_L4002: "Schiffsführer/innen in Binnenschifffahrt und Hafenverkehr",
  L1007_L2002_L3005_L4001: "Führer/innen von land- und forstwirtschaftlichen Maschinen",
  L1007_L2002_L3005_L4002: "Führer/innen von Erdbewegungs- und verwandten Maschinen",
  L1007_L2002_L3005_L4003:
    "Kranführer/innen, Aufzugsmaschinisten und Bediener/innen verwandter Hebeeinrichtungen",
  L1007_L2002_L3005_L4004: "Aufsichtskräfte - Bau- und Transportgeräteführung",
  L1009_L2001_L3001_L4001: "Berufe im Objekt-, Werte- und Personenschutz",
  L1009_L2001_L3001_L4002: "Berufe in Arbeitssicherheit und Sicherheitstechnik",
  L1009_L2001_L3001_L4003: "Berufe im Brandschutz",
  L1009_L2001_L3001_L4004: "Berufe in der Badeaufsicht",
  L1009_L2001_L3001_L4005: "Detektive/Detektivinnen",
  L1009_L2001_L3001_L4006: "Inkassobeauftragte",
  L1009_L2001_L3001_L4007:
    "Berufe in Objekt-, Personen-, Brandschutz, Arbeitssicherheit (sonstige spezifische Tätigkeitsangabe)",
  L1009_L2001_L3001_L4008:
    "Aufsichts- und Führungskräfte - Objekt-, Personen-, Brandschutz, Arbeitssicherheit",
  L1009_L2001_L3002_L4001: "Berufe im Polizeivollzugsdienst",
  L1009_L2001_L3002_L4002: "Berufe im Kriminaldienst",
  L1009_L2001_L3002_L4003: "Berufe im Gerichtsvollzug",
  L1009_L2001_L3002_L4004: "Berufe im Justizvollzugsdienst",
  L1009_L2001_L3003_L4001: "Berufe in der Gewerbeaufsicht",
  L1009_L2001_L3003_L4002: "Berufe in der Gesundheitsaufsicht und Hygieneüberwachung",
  L1009_L2001_L3003_L4003: "Berufe in der Lebensmittelkontrolle",
  L1009_L2001_L3003_L4004: "Berufe in der Desinfektion und Schädlingsbekämpfung",
  L1009_L2001_L3003_L4005:
    "Aufsichts- und Führungskräfte - Gewerbe- und Gesundheitsaufsicht, Desinfektion",
  L1009_L2002_L3001_L4001: "Berufe in der Reinigung (ohne Spezialisierung)",
  L1009_L2002_L3001_L4002: "Berufe in der Gebäudereinigung",
  L1009_L2002_L3001_L4003: "Berufe in der Glas- und Fensterreinigung",
  L1009_L2002_L3001_L4004: "Berufe in der Textilreinigung",
  L1009_L2002_L3001_L4005: "Berufe in der Maschinen- und Anlagenreinigung",
  L1009_L2002_L3001_L4006: "Berufe in der Fahrzeugreinigung",
  L1009_L2002_L3001_L4007: "Berufe in der Reinigung (sonstige spezifische Tätigkeitsangabe)",
  L1009_L2002_L3001_L4008: "Aufsichtskräfte - Reinigung",
  L1015_L2001_L3001_L4001: "Berufe im Einkauf",
  L1015_L2001_L3001_L4002:
    "Berufe im Vertrieb (außer Informations- und Kommunikationstechnologien)",
  L1015_L2001_L3001_L4003: "Handelsmakler/innen und Auktionatoren/Auktionatorinnen",
  L1015_L2001_L3001_L4004: "Kaufleute im Automatenservice",
  L1015_L2001_L3001_L4005: "Berufe im Geld- und Pfandverleih",
  L1015_L2001_L3001_L4006: "Berufe im Verleih (außer Geld- und Pfandverleih)",
  L1015_L2001_L3001_L4007: "Führungskräfte - Einkauf und Vertrieb",
  L1015_L2001_L3002_L4001: "Kaufleute im Handel (ohne Spezialisierung)",
  L1015_L2001_L3002_L4002: "Kaufleute im Groß- und Außenhandel",
  L1015_L2001_L3002_L4003: "Kaufleute im Handel (sonstige spezifische Tätigkeitsangabe)",
  L1015_L2001_L3002_L4004: "Führungskräfte - Handel",
  L1015_L2001_L3003_L4001: "Berufe in der Immobilienvermarktung und -verwaltung",
  L1015_L2001_L3003_L4002: "Berufe im Facility-Management",
  L1015_L2001_L3003_L4003: "Führungskräfte - Immobilienwirtschaft und Facility-Management",
  L1015_L2002_L3001_L4001: "Berufe im Verkauf (ohne Produktspezialisierung)",
  L1015_L2002_L3001_L4002: "Kassierer/innen und Kartenverkäufer/innen",
  L1015_L2002_L3001_L4003: "Verkaufsstand- und Marktverkäufer/innen",
  L1015_L2002_L3001_L4004:
    "Berufe im Verkauf (ohne Produktspezialisierung) (sonstige spezifische Tätigkeitsangabe)",
  L1015_L2002_L3001_L4005: "Aufsichts- und Führungskräfte - Verkauf",
  L1015_L2002_L3002_L4001:
    "Berufe im Verkauf von Bekleidung, Sportartikeln, Lederwaren und Schuhen",
  L1015_L2002_L3002_L4002: "Berufe im Verkauf von Schmuck und Uhren",
  L1015_L2002_L3002_L4003: "Berufe im Verkauf von Bürobedarf, Geschenk- und Spielwaren",
  L1015_L2002_L3002_L4004: "Berufe im Verkauf von Elektro-, Elektronik- und Haushaltswaren",
  L1015_L2002_L3002_L4005: "Berufe im Verkauf von Möbeln und Einrichtungsgegenständen",
  L1015_L2002_L3002_L4006: "Berufe im Verkauf von Garten-, Heimwerker-, Haustier- und Zoobedarf",
  L1015_L2002_L3002_L4007: "Berufe im Verkauf von Kraftfahrzeugen, Zweirädern und Zubehör",
  L1015_L2002_L3002_L4008: "Berufe im Verkauf (sonstige spezifische Tätigkeitsangabe)",
  L1015_L2002_L3003_L4001: "Berufe im Verkauf von Lebensmitteln (ohne Spezialisierung)",
  L1015_L2002_L3003_L4002: "Berufe im Verkauf von Back- und Konditoreiwaren",
  L1015_L2002_L3003_L4003: "Berufe im Verkauf von Fleischwaren",
  L1015_L2002_L3003_L4004:
    "Berufe im Verkauf von Lebensmitteln (sonstige spezifische Tätigkeitsangabe)",
  L1015_L2002_L3004_L4001: "Berufe im Verkauf von drogerie- und apothekenüblichen Waren",
  L1015_L2002_L3004_L4002: "Berufe im Verkauf von Sanitäts- und Medizinbedarf",
  L1015_L2002_L3005_L4001: "Berufe im Buchhandel",
  L1015_L2002_L3005_L4002: "Berufe im Kunst- und Antiquitätenhandel",
  L1015_L2002_L3005_L4003: "Berufe im Musikfachhandel",
  L1012_L2001_L3001_L4001: "Tourismuskaufleute",
  L1012_L2001_L3001_L4002: "Sport- und Fitnesskaufleute, Sportmanager/innen",
  L1012_L2001_L3001_L4003: "Animateure/Animateurinnen und Gästebetreuer/innen",
  L1012_L2001_L3001_L4004: "Reiseleiter/innen und Fremdenführer/innen",
  L1012_L2001_L3001_L4005: "Führungskräfte - Tourismus und Sport",
  L1012_L2001_L3002_L4001: "Hotelkaufleute",
  L1012_L2001_L3002_L4002: "Berufe im Hotelservice",
  L1012_L2001_L3002_L4003: "Aufsichts- und Führungskräfte - Hotellerie",
  L1012_L2001_L3003_L4001: "Berufe im Gastronomieservice (ohne Spezialisierung)",
  L1012_L2001_L3003_L4002: "Berufe in der Systemgastronomie",
  L1012_L2001_L3003_L4003: "Barkeeper/innen",
  L1012_L2001_L3003_L4004: "Berufe in der Gastronomie (sonstige spezifische Tätigkeitsangabe)",
  L1012_L2001_L3003_L4005: "Aufsichts- und Führungskräfte - Gastronomie und Systemgastronomie",
  L1012_L2001_L3004_L4001: "Berufe im Veranstaltungsservice und -management",
  L1014_L2001_L3001_L4001: "Geschäftsführer/innen und Vorstände",
  _L4001: "Angehörige gesetzgebender Körperschaften",
  _L4002: "Leitende Bedienstete von Interessenorganisationen",
  _L4003: "Betriebsinterne Wahlämter",
  L1014_L2001_L3003_L4001:
    "Berufe in der kaufmännischen und technischen Betriebswirtschaft (ohne Spezialisierung)",
  L1014_L2001_L3003_L4002: "Berufe in der Unternehmensorganisation und -planung",
  L1014_L2001_L3003_L4003: "Berufe in der Unternehmensberatung",
  L1014_L2001_L3003_L4004: "Berufe in der Wirtschaftsförderung",
  L1014_L2001_L3003_L4005:
    "Berufe in der Unternehmensorganisation und -strategie (sonstige spezifische Tätigkeitsangabe)",
  L1014_L2001_L3003_L4006:
    "Aufsichts- und Führungskräfte - Unternehmensorganisation und -strategie",
  L1014_L2001_L3004_L4001: "Büro- und Sekretariatskräfte (ohne Spezialisierung)",
  L1014_L2001_L3004_L4002:
    "Fremdsprachensekretäre/-sekretärinnen und Fremdsprachenkorrespondenten/-korrespondentinnen",
  L1014_L2001_L3004_L4003: "Dolmetscher/innen und Übersetzer/innen",
  L1014_L2001_L3004_L4004: "Steno- und Phonotypisten/-typistinnen",
  L1014_L2001_L3004_L4005: "Kodierer/innen, Korrekturleser/innen und verwandte Bürokräfte",
  L1014_L2001_L3004_L4006: "Berufe in der Auskunft und Kundeninformation",
  L1014_L2001_L3004_L4007: "Aufsichtskräfte - Büro- und Sekretariat",
  L1014_L2001_L3005_L4001: "Berufe in der Personalentwicklung und -sachbearbeitung",
  L1014_L2001_L3005_L4002: "Berufe in der Personaldienstleistung",
  L1014_L2001_L3005_L4003: "Führungskräfte - Personalwesen und -dienstleistung",
  L1003_L2001_L3001_L4001: "Bankkaufleute",
  L1003_L2001_L3001_L4002: "Anlageberater/innen - und sonstige Finanzdienstleistungsberufe",
  L1003_L2001_L3001_L4003: "Versicherungskaufleute",
  L1003_L2001_L3001_L4004: "Finanzanalysten/-analystinnen",
  L1003_L2001_L3001_L4005:
    "Berufe in Versicherungs- und Finanzdienstleistungen (sonstige spezifische Tätigkeitsangabe)",
  L1003_L2001_L3001_L4006: "Führungskräfte - Versicherungs- und Finanzdienstleistungen",
  L1003_L2001_L3002_L4001: "Berufe in der Buchhaltung",
  L1003_L2001_L3002_L4002: "Berufe in Kostenrechnung und Kalkulation",
  L1003_L2001_L3002_L4003: "Berufe im Controlling",
  L1003_L2001_L3002_L4004: "Berufe in Wirtschaftsprüfung",
  L1003_L2001_L3002_L4005: "Führungskräfte - Rechnungswesen, Controlling und Revision",
  L1003_L2001_L3003_L4001: "Berufe in der Steuerberatung",
  L1014_L2002_L3001_L4001:
    "Berufe in Rechtsberatung, -sprechung und -ordnung (ohne Spezialisierung)",
  L1014_L2002_L3001_L4002: "Assistenzkräfte in Rechtsanwaltskanzlei und Notariat",
  L1014_L2002_L3001_L4003: "Notare/Notarinnen",
  L1014_L2002_L3001_L4004: "Rechtsanwälte/-anwältinnen",
  L1014_L2002_L3001_L4005: "Staatsanwälte/-anwältinnen",
  L1014_L2002_L3001_L4006: "Richter/innen",
  L1014_L2002_L3001_L4007: "Berufe im Verfassungsschutz",
  L1014_L2002_L3001_L4008:
    "Berufe in Rechtsberatung, -sprechung und -ordnung (sonstige spezifische Tätigkeitsangabe)",
  L1014_L2002_L3001_L4009: "Führungskräfte - Rechtsberatung, -sprechung und -ordnung",
  L1014_L2002_L3002_L4001: "Berufe in der öffentlichen Verwaltung (ohne Spezialisierung)",
  L1014_L2002_L3002_L4002: "Berufe in der Sozialverwaltung und -versicherung",
  L1014_L2002_L3002_L4003: "Verwaltende Berufe im Sozial- und Gesundheitswesen",
  L1014_L2002_L3002_L4004: "Berufe in der Steuerverwaltung",
  L1014_L2002_L3002_L4005: "Berufe im Zolldienst",
  L1014_L2002_L3002_L4006: "Berufe in der Justizverwaltung",
  L1014_L2002_L3002_L4007:
    "Berufe in der öffentlichen Verwaltung (sonstige spezifische Tätigkeitsangabe)",
  L1014_L2002_L3002_L4008: "Aufsichts- und Führungskräfte - Verwaltung",
  L1014_L2002_L3003_L4001: "Berufe im Archivwesen",
  L1014_L2002_L3003_L4002: "Berufe im Bibliothekswesen",
  L1014_L2002_L3003_L4003: "Berufe im Dokumentations- und Informationsdienst",
  L1014_L2002_L3003_L4004: "Berufe in der medizinischen Dokumentation",
  L1014_L2002_L3003_L4005: "Führungskräfte - Medien-, Dokumentations- und Informationsdienste",
  L1004_L2001_L3001_L4001: "Medizinische Fachangestellte (ohne Spezialisierung)",
  L1004_L2001_L3001_L4002: "Zahnmedizinische Fachangestellte",
  L1004_L2001_L3001_L4003: "Podologen/Podologinnen",
  L1004_L2001_L3001_L4004: "Orthoptisten/Orthoptistinnen",
  L1004_L2001_L3001_L4005: "Tiermedizinische Fachangestellte",
  L1004_L2001_L3001_L4006: "Medizinische Fachangestellte (sonstige spezifische Tätigkeitsangabe)",
  L1004_L2001_L3002_L4001: "Medizinisch-technische Berufe im Laboratorium",
  L1004_L2001_L3002_L4002: "Medizinisch-technische Berufe in der Funktionsdiagnostik",
  L1004_L2001_L3002_L4003: "Medizinisch-technische Berufe in der Radiologie",
  L1004_L2001_L3002_L4004: "Medizinisch-technische Berufe in der Veterinärmedizin",
  L1004_L2001_L3002_L4005: "Führungskräfte - Medizinisches Laboratorium",
  L1004_L2001_L3003_L4001: "Berufe in der Gesundheits- und Krankenpflege (ohne Spezialisierung)",
  L1004_L2001_L3003_L4002: "Berufe in der Fachkrankenpflege",
  L1004_L2001_L3003_L4003: "Berufe in der Fachkinderkrankenpflege",
  L1004_L2001_L3003_L4004: "Berufe in der operations-/medizintechnischen Assistenz",
  L1004_L2001_L3003_L4005: "Berufe im Rettungsdienst",
  L1004_L2001_L3003_L4006: "Berufe in der Geburtshilfe und Entbindungspflege",
  L1004_L2001_L3003_L4007:
    "Berufe in der Gesundheits- und Krankenpflege (sonstige spezifische Tätigkeitsangabe)",
  L1004_L2001_L3003_L4008:
    "Aufsichts- und Führungskräfte - Gesundheits- und Krankenpflege, Rettungsdienst und Geburtshilfe",
  L1004_L2001_L3004_L4001: "Ärzte/Ärztinnen (ohne Spezialisierung)",
  L1004_L2001_L3004_L4002: "Fachärzte/-ärztinnen in der Kinder- und Jugendmedizin",
  L1004_L2001_L3004_L4003: "Fachärzte/-ärztinnen in der Inneren Medizin",
  L1004_L2001_L3004_L4004: "Fachärzte/-ärztinnen in der Chirurgie",
  L1004_L2001_L3004_L4005:
    "Fachärzte/-ärztinnen in den Bereichen Hautkrankheiten, Sinnes- und Geschlechtsorgane",
  L1004_L2001_L3004_L4006: "Fachärzte/-ärztinnen in der Anästhesiologie",
  L1004_L2001_L3004_L4007:
    "Fachärzte/-ärztinnen in der Neurologie, Psychiatrie, Psychotherapie und psychosomatischen Medizin",
  L1004_L2001_L3004_L4008: "Zahnärzte/-ärztinnen und Kieferorthopäden/-orthopädinnen",
  L1004_L2001_L3004_L4009: "Ärzte/Ärztinnen (sonstige spezifische Tätigkeitsangabe)",
  L1004_L2001_L3004_L4010: "Führungskräfte - Human- und Zahnmedizin",
  L1004_L2001_L3005_L4001: "Tierärzte/-ärztinnen (ohne Spezialisierung)",
  L1004_L2001_L3005_L4002: "Tierärzte/-ärztinnen für Groß- und Nutztiere",
  L1004_L2001_L3005_L4003: "Tierärzte/-ärztinnen für Haus- und Heimtiere",
  L1004_L2001_L3005_L4004: "Tierheilpraktiker/innen",
  L1004_L2001_L3005_L4005:
    "Berufe in der Tiermedizin und Tierheilkunde (sonstige spezifische Tätigkeitsangabe)",
  L1004_L2001_L3005_L4006: "Führungskräfte - Tiermedizin und Tierheilkunde",
  L1004_L2001_L3006_L4001: "Berufe in der nicht klinischen Psychologie",
  L1004_L2001_L3006_L4002: "Berufe in der klinischen Psychologie",
  L1004_L2001_L3006_L4003: "Berufe in der nicht ärztlichen Psychotherapie",
  L1004_L2001_L3007_L4001: "Berufe in der Physiotherapie",
  L1004_L2001_L3007_L4002: "Berufe in der Ergotherapie",
  L1004_L2001_L3007_L4003: "Berufe in der Sprachtherapie",
  L1004_L2001_L3007_L4004: "Berufe in der Musik- und Kunsttherapie",
  L1004_L2001_L3007_L4005: "Berufe in der Heilkunde und Homüopathie",
  L1004_L2001_L3007_L4006: "Berufe in der Diät- und Ernährungstherapie",
  L1004_L2001_L3007_L4007:
    "Berufe in der nicht ärztlichen Therapie und Heilkunde (sonstige spezifische Tätigkeitsangabe)",
  L1004_L2001_L3007_L4008: "Führungskräfte - Nicht ärztliche Therapie und Heilkunde",
  L1004_L2001_L3008_L4001: "Apotheker/innen, Pharmazeuten/Pharmazeutinnen",
  L1004_L2001_L3008_L4002: "Fachärzte/-ärztinnen in der Pharmakologie",
  L1004_L2001_L3008_L4003: "Berufe in der pharmazeutisch-technischen Assistenz",
  L1004_L2001_L3008_L4004: "Berufe in der Pharmazie (sonstige spezifische Tätigkeitsangabe)",
  L1004_L2001_L3008_L4005: "Führungskräfte - Pharmazie",
  L1004_L2002_L3001_L4001: "Berufe in der Altenpflege (ohne Spezialisierung)",
  L1004_L2002_L3001_L4002: "Berufe in der Altenpflege (sonstige spezifische Tätigkeitsangabe)",
  L1004_L2002_L3001_L4003: "Führungskräfte - Altenpflege",
  L1004_L2002_L3002_L4001: "Berufe in der Gesundheitsberatung",
  L1004_L2002_L3002_L4002: "Wellnessberufe",
  L1004_L2002_L3002_L4003: "Berufe in der Ernährungsberatung",
  L1004_L2002_L3002_L4004: "Qualitätsbeauftragte im Gesundheitswesen",
  L1004_L2002_L3002_L4005:
    "Berufe in Ernährungs- und Gesundheitsberatung, Wellness (sonstige spezifische Tätigkeitsangabe)",
  _L4004: "Berufe im Friseurgewerbe",
  _L4005: "Berufe in der Kosmetik",
  _L4006: "Tätowierer/innen und Piercer/innen",
  _L4007: "Berufe in der Maskenbildnerei",
  _L4008: "Aufsichtskräfte - Körperpflege",
  L1004_L2002_L3004_L4001: "Berufe im Bestattungswesen",
  L1004_L2002_L3004_L4002: "Aufsichts- und Führungskräfte - Bestattungswesen",
  L1004_L2002_L3005_L4001: "Berufe in der Medizintechnik (ohne Spezialisierung)",
  L1004_L2002_L3005_L4002: "Berufe in der Orthopädie- und Rehatechnik",
  L1004_L2002_L3005_L4003: "Berufe in der Augenoptik",
  L1004_L2002_L3005_L4004: "Berufe in der Hörgeräteakustik",
  L1004_L2002_L3005_L4005: "Berufe in der Zahntechnik",
  L1004_L2002_L3005_L4006: "Aufsichts- und Führungskräfte - Medizin-, Orthopädie- und Rehatechnik",
  L1010_L2001_L3001_L4001: "Berufe in der Kinderbetreuung und -erziehung",
  L1010_L2001_L3001_L4002: "Berufe in der Sozialarbeit und Sozialpädagogik",
  L1010_L2001_L3001_L4003: "Berufe in Heilerziehungspflege und Sonderpädagogik",
  L1010_L2001_L3001_L4004: "Berufe in der Haus- und Familienpflege",
  L1010_L2001_L3001_L4005: "Berufe in der Sozial-, Erziehungs- und Suchtberatung",
  L1010_L2001_L3001_L4006:
    "Aufsichts- und Führungskräfte - Erziehung, Sozialarbeit, Heilerziehungspflege",
  L1010_L2001_L3002_L4001: "Berufe in der Hauswirtschaft",
  L1010_L2001_L3002_L4002: "Berufe in der Verbraucherberatung",
  L1010_L2001_L3002_L4003: "Aufsichtskräfte - Hauswirtschaft und Verbraucherberatung",
  L1010_L2001_L3003_L4001: "Berufe in der Theologie",
  L1010_L2001_L3003_L4002: "Berufe in der Gemeindearbeit",
  L1010_L2001_L3003_L4003: "Angehörige geistlicher Orden und Mutterhäuser",
  L1010_L2001_L3003_L4004:
    "Berufe in der Theologie und Gemeindearbeit (sonstige spezifische Tätigkeitsangabe)",
  L1010_L2001_L3003_L4005: "Führungskräfte - Theologie und Gemeindearbeit",
  L1010_L2002_L3001_L4001: "Lehrkräfte in der Primarstufe",
  L1010_L2002_L3001_L4002: "Lehrkräfte in der Sekundarstufe",
  L1010_L2002_L3001_L4003: "Lehrkräfte an Sonderschulen",
  L1010_L2002_L3001_L4004: "Berufe in der Lehrerausbildung",
  L1010_L2002_L3001_L4005:
    "Lehrkräfte an allgemeinbildenden Schulen (sonstige spezifische Tätigkeitsangabe)",
  L1010_L2002_L3001_L4006: "Führungskräfte - Allgemeinbildende Schulen",
  L1010_L2002_L3002_L4001: "Lehrkräfte für berufsbildende Fächer",
  L1010_L2002_L3002_L4002: "Berufe in der betrieblichen Ausbildung und Betriebspädagogik",
  L1010_L2002_L3002_L4003:
    "Führungskräfte - Berufsschulen, betriebliche Ausbildung und Betriebspädagogik",
  L1010_L2002_L3003_L4001: "Berufe in der Hochschullehre und -forschung",
  L1010_L2002_L3003_L4002: "Führungskräfte - Hochschullehre und -forschung",
  L1010_L2002_L3004_L4001: "Berufe in der Erwachsenenbildung (ohne Spezialisierung)",
  L1010_L2002_L3004_L4002: "Berufe in der Musikpädagogik",
  L1010_L2002_L3004_L4003: "Berufe in der Religionspädagogik",
  L1010_L2002_L3004_L4004: "Berufe in der Kunst- und Theaterpädagogik",
  L1010_L2002_L3004_L4005: "Berufe im IT-Anwendungstraining",
  L1010_L2002_L3004_L4006: "(Fremd-)Sprachenlehrer/innen",
  L1010_L2002_L3004_L4007:
    "Lehrkräfte an außerschulischen Bildungseinrichtungen (sonstige spezifische Tätigkeitsangabe)",
  L1010_L2002_L3004_L4008: "Führungskräfte - Außerschulische Bildungseinrichtungen",
  L1010_L2002_L3005_L4001: "Sportlehrer/innen (ohne Spezialisierung)",
  L1010_L2002_L3005_L4002: "Fahrlehrer/innen",
  L1010_L2002_L3005_L4003: "Fluglehrer/innen",
  L1010_L2002_L3005_L4004: "Tanzlehrer/innen",
  L1010_L2002_L3005_L4005: "Trainer/innen - Ballsportarten",
  L1010_L2002_L3005_L4006: "Trainer/innen - Fitness und Gymnastik",
  L1010_L2002_L3005_L4007: "Sportlehrer/innen (sonstige spezifische Tätigkeitsangabe)",
  L1016_L2003_L3001_L4001: "Berufe in Sprach- und Literaturwissenschaften (ohne Spezialisierung)",
  L1016_L2003_L3001_L4002: "Berufe in der Germanistik",
  L1016_L2003_L3001_L4003: "Berufe in der Anglistik und Amerikanistik",
  L1016_L2003_L3001_L4004: "Berufe in der Romanistik",
  L1016_L2003_L3001_L4005: "Berufe in der Slawistik und verwandten Bereichen",
  L1016_L2003_L3001_L4006: "Berufe in der Arabistik und Orientalistik",
  L1016_L2003_L3001_L4007: "Berufe in Sprach- und Literaturwissenschaften des asiatischen Raums",
  L1016_L2003_L3001_L4008: "Berufe in der Altphilologie",
  L1016_L2003_L3001_L4009:
    "Berufe in Sprach- und Literaturwissenschaften (sonstige spezifische Tätigkeitsangabe)",
  L1016_L2003_L3002_L4001: "Berufe in Philosophie, Religion und Ethik",
  L1016_L2003_L3002_L4002: "Berufe in Geschichtswissenschaften",
  L1016_L2003_L3002_L4003: "Berufe in der Archäologie",
  L1016_L2003_L3002_L4004: "Berufe in Medien- und Theaterwissenschaft",
  L1016_L2003_L3002_L4005: "Berufe in der Regionalwissenschaft",
  L1016_L2003_L3002_L4006: "Berufe in der Anthropologie und Ethnologie",
  L1016_L2003_L3003_L4001: "Berufe in der Politologie",
  L1016_L2003_L3003_L4002: "Berufe in der Soziologie",
  L1016_L2003_L3003_L4003: "Berufe in der Erziehungswissenschaft",
  L1016_L2003_L3003_L4004: "Berufe in der Markt- und Meinungsforschung",
  L1016_L2003_L3003_L4005: "Berufe in der Demografie",
  L1016_L2003_L3003_L4006:
    "Berufe in Gesellschaftswissenschaften (sonstige spezifische Tätigkeitsangabe)",
  L1016_L2003_L3004_L4001: "Berufe in Wirtschaftswissenschaften (ohne Spezialisierung)",
  L1016_L2003_L3004_L4002:
    "Berufe in Wirtschaftswissenschaften (sonstige spezifische Tätigkeitsangabe)",
  L1013_L2001_L3001_L4001: "Berufe in Werbung und Marketing",
  L1013_L2001_L3001_L4002: "Berufe im Dialogmarketing",
  L1013_L2001_L3001_L4003: "Berufe im Kundenmanagement",
  L1013_L2001_L3001_L4004: "Führungskräfte - Werbung und Marketing",
  _L4009: "Berufe in der Öffentlichkeitsarbeit",
  _L40010: "Führungskräfte - öffentlichkeitsarbeit",
  L1013_L2001_L3003_L4001: "Verlags- und Medienkaufleute (ohne Spezialisierung)",
  L1013_L2001_L3003_L4002: "Verlags- und Medienkaufleute (sonstige spezifische Tätigkeitsangabe)",
  L1013_L2001_L3003_L4003: "Führungskräfte - Verlags- und Medienwirtschaft",
  L1013_L2001_L3004_L4001: "Redakteure/Redakteurinnen und Journalisten/Journalistinnen",
  L1013_L2001_L3004_L4002: "Lektoren/Lektorinnen",
  L1013_L2001_L3004_L4003: "Autoren/Autorinnen und Schriftsteller/innen",
  L1013_L2001_L3004_L4004: "Führungskräfte - Redaktion und Journalismus",
  L1013_L2002_L3001_L4001: "Berufe im Produkt- und Industriedesign",
  L1013_L2002_L3002_L4001: "Berufe in der Innenarchitektur",
  L1013_L2002_L3002_L4002: "Berufe im visuellen Marketing",
  L1013_L2002_L3002_L4003: "Berufe in der Raumausstattung",
  L1013_L2002_L3002_L4004:
    "Aufsichtskräfte - Innenarchitektur, visuelles Marketing, Raumausstattung",
  L1013_L2002_L3003_L4001: "Berufe in Kunsthandwerk und bildender Kunst (ohne Spezialisierung)",
  L1013_L2002_L3003_L4002: "Berufe in der Bildhauerei",
  L1013_L2002_L3003_L4003: "Kunstmaler/innen und Zeichner/innen",
  L1013_L2002_L3003_L4004: "Berufe in der Drechslerei und Spielzeugherstellung",
  L1013_L2002_L3003_L4005: "Berufe im Vergolderhandwerk",
  L1013_L2002_L3003_L4006: "Berufe in der Wachszieherei",
  L1013_L2002_L3003_L4007:
    "Berufe in Kunsthandwerk und bildender Kunst (sonstige spezifische Tätigkeitsangabe)",
  L1013_L2002_L3003_L4008: "Aufsichtskräfte - Kunsthandwerk und bildende Kunst",
  L1013_L2002_L3004_L4001: "Berufe in der kunsthandwerklichen Keramikgestaltung",
  L1013_L2002_L3004_L4002: "Berufe in der kunsthandwerklichen Glas-, Keram- und Porzellanmalerei",
  L1013_L2002_L3004_L4003: "Berufe in der kunsthandwerklichen Glasbläserei",
  L1013_L2002_L3004_L4004: "Aufsichtskräfte - Kunsthandwerkliche Keramik- und Glasgestaltung",
  L1013_L2002_L3005_L4001: "Berufe in der kunsthandwerklichen Metallgestaltung",
  L1013_L2002_L3005_L4002:
    "Berufe in der kunsthandwerklichen Schmuckwarenherstellung, Edelstein- und Edelmetallbearbeitung",
  L1013_L2002_L3005_L4003: "Berufe in der Gravur",
  L1013_L2002_L3005_L4004: "Berufe in der Schilder- und Lichtreklameherstellung",
  L1013_L2002_L3005_L4005: "Aufsichtskräfte - Kunsthandwerkliche Metallgestaltung",
  L1013_L2002_L3006_L4001: "Berufe im Musikinstrumentenbau (ohne Spezialisierung)",
  L1013_L2002_L3006_L4002: "Berufe im Streich- und Zupfinstrumentenbau",
  L1013_L2002_L3006_L4003: "Berufe im Holzblasinstrumentenbau",
  L1013_L2002_L3006_L4004: "Berufe im Metallblasinstrumentenbau",
  L1013_L2002_L3006_L4005: "Berufe im Klavier- und Cembalobau",
  L1013_L2002_L3006_L4006: "Berufe im Orgel- und Harmoniumbau",
  L1013_L2002_L3006_L4007: "Berufe im Musikinstrumentenbau (sonstige spezifische Tätigkeitsangabe)",
  L1013_L2002_L3006_L4008: "Aufsichtskräfte - Musikinstrumentenbau",
  L1000_L2001_L3001_L4001: "Musiker/innen",
  L1000_L2001_L3001_L4002: "Sänger/innen",
  L1000_L2001_L3001_L4003: "Dirigenten/Dirigentinnen",
  L1000_L2001_L3001_L4004: "Komponisten/Komponistinnen",
  L1000_L2001_L3001_L4005:
    "Musik-, Gesangs- und Dirigententätigkeiten (sonstige spezifische Tätigkeitsangabe)",
  L1000_L2001_L3002_L4001: "Schauspieler/innen",
  L1000_L2001_L3002_L4002: "Tänzer/innen und Choreografen/Choreografinnen",
  L1000_L2001_L3002_L4003: "Mannequins, Dressmen und sonstige Models",
  L1000_L2001_L3002_L4004: "Athleten/Athletinnen und Berufssportler/innen",
  L1000_L2001_L3002_L4005: "Berufe für personenbezogene Dienstleistungen",
  L1000_L2001_L3002_L4006:
    "Berufe in Schauspiel, Tanz und Bewegungskunst (sonstige spezifische Tätigkeitsangabe)",
  L1000_L2001_L3003_L4001: "Berufe in Moderation und Unterhaltung (ohne Spezialisierung)",
  L1000_L2001_L3003_L4002: "Komiker/innen und Kabarettisten/Kabarettistinnen",
  L1000_L2001_L3003_L4003: "Zauberer/Zauberinnen und Illusionisten/Illusionistinnen",
  L1000_L2001_L3003_L4004: "Hörfunk- und Fernsehmoderatoren/-moderatorinnen",
  L1000_L2001_L3003_L4005: "Berufe im Bereich Glücks- und Wettspiel",
  L1000_L2001_L3003_L4006:
    "Berufe in Moderation und Unterhaltung (sonstige spezifische Tätigkeitsangabe)",
  L1000_L2001_L3004_L4001:
    "Berufe in der Theater-, Film- und Fernsehproduktion (ohne Spezialisierung)",
  L1000_L2001_L3004_L4002: "Berufe in der Regie",
  L1000_L2001_L3004_L4003:
    "Berufe in der Theater-, Film- und Fernsehproduktion (sonstige spezifische Tätigkeitsangabe)",
  L1000_L2001_L3004_L4004: "Aufsichts- und Führungskräfte - Theater-, Film- und Fernsehproduktion",
  L1000_L2001_L3005_L4001: "Berufe in der Veranstaltungs- und Bühnentechnik",
  L1000_L2001_L3005_L4002: "Berufe in der Kameratechnik",
  L1000_L2001_L3005_L4003: "Berufe in der Bild- und Tontechnik",
  L1000_L2001_L3005_L4004:
    "Berufe in der Veranstaltungs-, Kamera- und Tontechnik (sonstige spezifische Tätigkeitsangabe)",
  L1000_L2001_L3005_L4005: "Aufsichtskräfte - Veranstaltungs-, Kamera- und Tontechnik",
  L1000_L2001_L3006_L4001: "Berufe in der Bühnen- und Kostümbildnerei",
  L1000_L2001_L3006_L4002: "Berufe in der Requisite",
  L1000_L2001_L3006_L4003: "Aufsichtskräfte - Bühnen- und Kostümbildnerei, Requisite",
  L1000_L2001_L3007_L4001: "Museumsberufe (ohne Spezialisierung)",
  L1000_L2001_L3007_L4002: "Berufe in der Museums- und Ausstellungstechnik",
  L1000_L2001_L3007_L4003: "Kunstsachverständige",
  L1000_L2001_L3007_L4004: "Führungskräfte - Museum"
};
module.exports = jobCategoryIdToNameMapping;
